import store from "@/store/index";
import { KONGGE_ELEMENT } from "@/subjects/constant";
export const toogleScore = (show = true) => {
  document.querySelectorAll(".topic-wrapper iframe").forEach((iframe) => {
    if (iframe.contentWindow) {
      iframe.contentWindow.document.body.className = show
        ? "show-score view"
        : "hide-score view";
    }
  });
};
// 超出题号判断
export function overNum(_this, maxNum) {
  let flag = false;
  let lenArr = [];
  for (let i = _this.formData.start; i <= _this.formData.end; i++) {
    lenArr.push(i);
  }
  _this.formData.items.length &&
    _this.formData.items.forEach((item) => {
      lenArr.push(item.no);
    });
  console.log("lenArr", lenArr);
  lenArr = lenArr.filter((item, index, arr) => {
    return arr.indexOf(item) === index;
  });
  if (lenArr.length > maxNum) {
    _this.$message({
      message: "超出" + maxNum + "题，无法添加！",
      type: "warning",
      customClass: "mzindex",
    });
    _this.addButtonLoading = false;
    flag = true;
  }
  return flag;
}
//考生信息情况影响排版
export function studentMsgEffect() {
  let answerPanelState = store.state.answerPanel;
  const { answerSheet } = answerPanelState;
  const {
    acCardStudentCodeType,
    acCardPanes,
    acCardExamNumber,
    acCardMissSign,
  } = answerSheet;
  let type = 0;
  if (acCardStudentCodeType === 1) {
    // 考号填写模式 => 条码
    type = acCardMissSign ? 4 : 1;
    acCardPanes === 3 ? (type = 5) : (type = 1);
  } else if (acCardStudentCodeType === 2) {
    // 考号填写模式 => 手写考号
    type = acCardMissSign ? 5 : 2;
  } else if (acCardStudentCodeType === 0) {
    // 考号填写模式 => 填涂
    if (
      (acCardPanes === 1 && acCardExamNumber > 10) ||
      (acCardPanes === 2 && acCardExamNumber > 9) ||
      (acCardPanes === 3 && acCardExamNumber > 8)
    ) {
      type = 3;
    }
  }
  store.commit("answerPanel/SET_CARD_SET_TYPE", type);
}

// 编辑失焦延时

export function nextAction(fun, v) {
  const timer = setTimeout(() => {
    fun && fun.call(this, v);
    clearTimeout(timer);
  }, 300);
}

export function winZoom() {
  let ratio = 0,
    screen = window.screen, //有关用户屏幕的信息
    ua = navigator.userAgent.toLowerCase(); //声明了浏览器用于 HTTP 请求的用户代理头的值
  if (~ua.indexOf("firefox")) {
    //火狐浏览器
    if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio; //获取设备像素比
    }
  } else if (~ua.indexOf("trident")) {
    //IE浏览器
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI; //获取设备像素点比
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    //大专栏  判断浏览器是否缩放>
    ratio = window.outerWidth / window.innerWidth; //屏幕宽度显示宽度比
  }
  if (ratio) {
    ratio = Math.round(ratio * 100);
  }
  // 360安全浏览器下的innerWidth包含了侧边栏的宽度
  if (ratio !== 100) {
    if (ratio >= 95 && ratio <= 105) {
      ratio = 100;
    }
  }
  return ratio;
}
export function setObjectiveHeight(newData) {
  // let answerPanelState = store.state.answerPanel;
  // const { answerSheet } = answerPanelState;
  // const { acCardPanes } = answerSheet;
  // const items = subjects.items;
  // const newRowNum = newData.rowNum > newData.items.length ? newData.items.length : newData.rowNum;
  // const groupNum = Math.ceil(items.length / newRowNum);
  // let rowHeightList = [];
  // if (!newData.diffLayout) {
  //   // 横排 每行的高度是相同的 需要算数有几行（最后一行少于5个 高度为100）
  //   // 多少个小组
  //   let rowWidth = 0;
  //   let rowNum = 0;
  //   let lastRowNum = 0;
  //   for (let i = 1; i < groupNum + 1; i++) {
  //     const maxNum = getMaxOptionsNum(i, 1, items, newData);
  //     const groupWidth = (maxNum + 1) * 24 + 20; //每组的宽度(+1 => 题号) 20是外边距
  //     rowWidth += groupWidth;
  //     if (acCardPanes === 3) {
  //       //判断是否是三栏 宽度只有 451px
  //       if (rowWidth > 505) {
  //         // 判断是否超出宽度 如果超出设置
  //         rowWidth = groupWidth;
  //         rowNum++;
  //         lastRowNum = i;
  //       }
  //     } else {
  //       //一栏和二栏是 652px 改版之后 一行可以放5组 一栏二栏是706
  //       if (rowWidth >= 704) {
  //         // 判断是否超出宽度 如果超出设置
  //         rowWidth = groupWidth;
  //         rowNum++;
  //         lastRowNum = i;
  //       }
  //     }
  //   }
  //   rowNum = rowNum > 0 ? rowNum + 1 : 1;
  //   if (groupNum - lastRowNum > 0) {
  //     // 最后一行不止一组
  //     for (let i = 0; i < rowNum; i++) {
  //       rowHeightList.push(20 + newRowNum * 18);
  //       // if (newRowNum >= 5) {
  //       //   rowHeightList.push(20 + newRowNum * 18);
  //       // } else {
  //       //   rowHeightList.push(100);
  //       // }
  //     }
  //   } else {
  //     // 最后一行只有一组
  //     for (let i = 0; i < rowNum; i++) {
  //       if (i < rowNum - 1) {
  //         rowHeightList.push(20 + newRowNum * 18);
  //         // if (newRowNum >= 5) {
  //         //   rowHeightList.push(20 + newRowNum * 18)
  //         // } else {
  //         //   rowHeightList.push(100)
  //         // }
  //       } else {
  //         rowHeightList.push(
  //           20 + (items.length - newRowNum * (lastRowNum > 0 ? lastRowNum - 1 : 0)) * 18
  //         );
  //         // if (Math.abs(items.length - newRowNum* (lastRowNum >0 ? (lastRowNum -1) : 0)) >= 5) {
  //         //   rowHeightList.push(20 + (items.length - newRowNum* (lastRowNum >0 ? (lastRowNum -1) : 0)) * 18)
  //         // } else {
  //         //   rowHeightList.push(100)
  //         // }
  //       }
  //     }
  //   }
  // } else {
  //   // 竖排 每排的组数是相同的（先计算出每排有几组即有多少题 找出每排最高的那个高度）
  //   // 这里算group的时候总宽度减去20 是 每组有一个20的margin值 当每行最后一组题目的时候 是不能算20margin值的
  //   const group = ((acCardPanes === 3 ? (505-20) : (704-20)) / (20 + 24 * newRowNum));
  //   // const group = Math.floor((acCardPanes === 3 ? 505 : 706) / (20 + 24 * newRowNum));
  //   const len = Math.ceil(items.length/group/newRowNum);
  //   const aaa = (items.length/group/newRowNum);
  //   // const len = Math.ceil(items.length / (group * newRowNum));
  //   for (let k = 1; k < len + 1; k++) {
  //     const maxNum = getMaxOptionsNum(k, Math.floor(group), items, newData);

  //     console.log('竖排每组最大高度', 'maxNum', maxNum);
  //     rowHeightList.push((maxNum + 1) * 18 + 20); // 我尊你为最强
  //   }
  // }
  return new Promise((resolve, reject) => {
    let rowHeightList = [];
    const timer = setTimeout(() => {
      const objectiveEls = document.querySelectorAll(
        ".editor-wrapper .objective-content"
      );
      let objectItems = [];
      Array.from(objectiveEls).forEach((el) => {
        const thId = el && el.getAttribute("data-th");
        if (thId == newData.th) {
          objectItems = objectItems.concat(
            Array.from(el && el.querySelectorAll(".obj-cont .object-item"))
          );
        }
      });
      // const objectItems = Array.from(currentEl && currentEl.querySelectorAll('.obj-cont .object-item'));
      rowHeightList = [];
      objectItems.forEach((item) => {
        rowHeightList.push(item.offsetHeight + 10);
      });
      console.log("obj-cont", objectItems, rowHeightList);
      newData = { ...newData, rowHeightList };
      resolve(newData);
      clearTimeout(timer);
    }, 100);
  });
}

// 横排 每组最大的选项数
function getMaxOptionsNum(i, group, items, newData) {
  let optionNum = 0;
  const rowNum = newData.rowNum * group;
  const stepLen =
    i * newData.rowNum * group > items.length
      ? items.length
      : i * newData.rowNum * group;
  for (let j = (i - 1) * rowNum; j < stepLen; j++) {
    if (j === (i - 1) * rowNum) {
      optionNum =
        (items[(i - 1) * rowNum] && items[(i - 1) * rowNum].optionNum) || 0;
    } else {
      if (items[j] && items[j].optionNum > optionNum) {
        optionNum = (items[j] && items[j].optionNum) || 0;
      }
    }
  }
  return optionNum;
}

/**
 * 提取字符串中的中文
 * @param {string} str 提取的字符串
 * @return {string} 返回中文汉字
 */
export function getChinese(str) {
  if (str != null && str != "") {
    var reg = /[\u4e00-\u9fa5]|[\d+]/g;
    return str.match(reg) ? str.match(reg).join(""): str;
  } else return "";
}

/**
 * 检查span后面的空格是否有#8302 下载pdf需要 不然不显示下划线
 * @param {string} str 待格式化的str
 * @return {string} 返回带有#8302的字符串
 */
export function appendKONGGEToSPAN(str) {
  str && str.split(KONGGE_ELEMENT);
  let arrStr = str.split(KONGGE_ELEMENT);
  if (arrStr) {
    return arrStr
      .map((item) => {
        return item.indexOf("&#8203") != -1
          ? item
          : item.replace(/&nbsp+/g, "&nbsp;&#8203");
      })
      .join(KONGGE_ELEMENT);
  } else {
    return str || "";
  }
}
